import { client } from './client';

export interface EditProfileData {
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  country: string;
  state: string;
  password: string;
}

export const userService = {
  async editProfile(data: EditProfileData): Promise<void> {
    await client.post('/user/edit-profile', data);
  },

  async changePassword(oldPassword: string, newPassword: string): Promise<void> {
    await client.post('/user/change-password', { oldPassword, newPassword });
  },
};
